import { BookOpen, Volume2Icon, VolumeOffIcon, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { CardHeader } from "@/components/ui/card";

type QuizHeaderProps = {
  currentIndex: number;
  totalCount: number;
  isMuted: boolean;
  onExit: () => void;
  onToggleMute: () => void;
};

export function QuizHeader({ currentIndex, totalCount, isMuted, onExit, onToggleMute }: QuizHeaderProps) {
  return (
    <CardHeader className="flex items-center justify-between sm:pt-0 px-5 sm:px-4">
      {/* 종료 버튼 */}
      <Button variant="ghost" size="icon" onClick={onExit}>
        <X className="size-5 text-muted-foreground" />
      </Button>

      {/* 퀴즈 인덱스 */}
      <div className="flex items-center gap-1.5 rounded-full px-4 py-1.5">
        <BookOpen className="size-3.5 text-muted-foreground" />
        <span className="text-sm font-semibold text-muted-foreground">
          {currentIndex + 1} / {totalCount}
        </span>
      </div>

      {/* 음소거 버튼 */}
      <Button variant="ghost" size="icon" onClick={onToggleMute}>
        {isMuted ? (
          <VolumeOffIcon className="size-5 text-muted-foreground" />
        ) : (
          <Volume2Icon className="size-5 text-muted-foreground" />
        )}
      </Button>
    </CardHeader>
  );
}
